import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComingSoonPageComponent } from './composants/coming-soon-page/coming-soon-page.component';
import { AddPotifRecComponent } from './composants/add-potif-rec/add-potif-rec.component';
import { DocumentAdminComponent } from './composants/document-admin/document-admin.component';
import { ViewDocumentComponent } from './composants/view-document/view-document.component';
import { SettingsComponent } from './composants/settings/settings.component';
import { HeaderComponent } from './composants/header/header.component';
import { FooterComponent } from './composants/footer/footer.component';

const routes: Routes = [
  
{ path: 'settings', component: SettingsComponent,
    
},

{ path: 'view-documents', component: DocumentAdminComponent,
    
},
{ path: 'view-documents/:id', component: ViewDocumentComponent,
    
},


{ path: 'add-motif', component: AddPotifRecComponent,
    
},
{ path: 'coming-soon', component: ComingSoonPageComponent,
    
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
